import React, { useEffect, useRef, useState } from "react";
import "./Itrreports.css";
import axios from "axios";
import { toast } from "react-toastify";
import back from "../../imgs/backexam.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Itrreports = (props) => {
  const { t } = useTranslation();

  const [input, setInput] = useState({
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    kno: "",
    kname: "",
    lastkhadya: "",
    lastadv: "",
    lastdate: "",
    dno: "",
    name: "",
    khname: "",
    searchsank: "",
  });

  const inputRefs = useRef([]);
  const [DataSource, setDataSource] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [value, setValue] = useState("");
  const [partyData, setPartydata] = useState([]);
  const [khrtype, setKhrtype] = useState("retan");
  const navigate = useNavigate();
  const [wait, setWait] = useState(false);

  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);

  const handlertype = (type) => {
    setKhrtype(type);
  };

  useEffect(() => {
    setDataSource([]);
    setTableFilter([]);
    setValue("");
  }, [khrtype]);

  function handleEnterKey(event, currentIndex) {
    if (event.keyCode === 8) {
      if (event.target.name === "time") {
        setInput((prev) => ({ ...prev, time: "" }));
      } else if (event.target.name === "type") {
        setInput((prev) => ({ ...prev, type: "" }));
      }
    }

    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      let nextIndex = null;

      if (currentIndex === 2) {
        if (input.name !== "") nextIndex = currentIndex + 1;
        else nextIndex = currentIndex;
      } else {
        nextIndex = currentIndex + 1;
      }

      if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
    }
  }

  const filteData = (e) => {
    const searchValue = e.target.value.trim();

    if (searchValue !== "") {
      setValue(searchValue);
      const filtertable = DataSource.filter((o) => String(o.kno) === searchValue);
      setTableFilter([...filtertable]);
    } else {
      setValue(searchValue);
      setTableFilter([...DataSource]);
    }
  };

  const showprint = () => {
    if (DataSource && DataSource.length > 0) {
      localStorage.setItem("date1print", input.date1);
      localStorage.setItem("date2print", input.date2);
      localStorage.setItem("irpttype", khrtype);

      const url = "/itrreportprint";
      window.open(url, "_blank");
    } else {
      notifyerror(t("Itrreports.toast.noDataForPeriod"));
    }
  };

  const handleChange = async (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;

    setInput((prev) => ({ ...prev, [name]: valuecurrent }));

    if (name === "date2") {
      const date1 = new Date(input.date1);
      const date2 = new Date(valuecurrent);
      const differenceInDays = (date2 - date1) / (1000 * 60 * 60 * 24);

      if (differenceInDays <= 30) {
        setInput((prev) => ({ ...prev, [name]: valuecurrent }));
      } else {
        notifyerror(t("Itrreports.toast.reportLimitOneMonth"));
        setInput((prev) => ({ ...prev, [name]: new Date().toISOString().substr(0, 10) }));
      }
    }
  };

  const getkhpurreport = () => {
    setValue("");
    setWait(true);

    var mainuser2 = jsEncode.encode("mamapr", 125);
    let landingphp = "";

    if (khrtype === "retan") landingphp = "getretanmedireport.php";
    else if (khrtype === "karj") landingphp = "getkarjreportbydate.php";
    else if (khrtype === "sanghpur") landingphp = "getsanghpurreportbydate.php";
    else if (khrtype === "shares") landingphp = "getsharesreportbydate.php";

    let rawData = {
      date1: input.date1,
      date2: input.date2,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);

    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        if (response.data && response.data.length > 0) {
          setDataSource(response.data);
          setTableFilter(response.data);
          setWait(false);
        } else {
          notifyerror(t("Itrreports.toast.noData"));
          setDataSource([]);
          setTableFilter([]);
          setWait(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setWait(false);
      });
  };

  function formatDate(inputDate) {
    if (inputDate) {
      const parts = inputDate.split("-");
      if (parts.length !== 3) return "";

      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const year = parts[0];
      const month = parseInt(parts[1]) - 1;
      const day = parts[2];

      return `${day}-${months[month]}-${year}`;
    }
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  useEffect(() => {
    getkhpartylist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getkhpartylist() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios
      .post("https://excellentdairy.com/dairy/php/cust/getkhpartylist.php", {
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data && response.data.length > 0) {
          setPartydata(response.data);
          localStorage.setItem("dlist", JSON.stringify(response.data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (input.dno === "") {
      setInput((prev) => ({ ...prev, name: "" }));
    } else {
      let custlisttemp = partyData || [];
      let found = "";
      for (let i = 0; i < custlisttemp.length; i++) {
        const user = custlisttemp[i];
        if (user.kno === input.dno) {
          found = user.name;
          break;
        }
      }
      setInput((prev) => ({ ...prev, name: found || "" }));
    }
  }, [input.dno, partyData]);

  const dash = t("Itrreports.common.dash");

  // ✅ in this file search is useful for these report types
  const isSearchEnabled = khrtype === "retan" || khrtype === "karj" || khrtype === "sanghpur" || khrtype === "shares";

  const rowsToShow = value.length > 0 ? tableFilter : DataSource;

  return (
    <>
      <div className="sanklanmain">
        <div className="firstrowsank">
          <img onClick={props.visibility} className="back" src={back} alt="" />
          <div className="colmain">
            <div className="firstrow2">
              <div className="rowbill">
                <>
                  <div className="mb-2">
                    <span className="subheadsank">{t("Itrreports.filters.date")}</span>
                    <input
                      onKeyDown={(e) => handleEnterKey(e, 0)}
                      ref={(ref) => (inputRefs.current[0] = ref)}
                      type="date"
                      className="form-control"
                      autoComplete="off"
                      id="date1"
                      name="date1"
                      value={input.date1}
                      onChange={handleChange}
                    />
                  </div>

                  <span className="subheadbill">{t("Itrreports.filters.to")}</span>

                  <div className="mb-2">
                    <span className="subheadsank">{t("Itrreports.filters.date")}</span>
                    <input
                      onKeyDown={(e) => handleEnterKey(e, 1)}
                      ref={(ref) => (inputRefs.current[1] = ref)}
                      type="date"
                      className="form-control"
                      autoComplete="off"
                      id="date2"
                      name="date2"
                      value={input.date2}
                      onChange={handleChange}
                    />
                  </div>
                </>

                <div className="mb-2">
                  {wait ? (
                    <button
                      ref={(ref) => (inputRefs.current[4] = ref)}
                      type="submit"
                      id="show"
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("Itrreports.common.loading")}
                    </button>
                  ) : (
                    <button
                      onClick={getkhpurreport}
                      ref={(ref) => (inputRefs.current[4] = ref)}
                      type="submit"
                      id="show"
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("Itrreports.buttons.viewReport")}
                    </button>
                  )}

                  <button
                    onClick={showprint}
                    ref={(ref) => (inputRefs.current[4] = ref)}
                    type="submit"
                    id="print"
                    className="btn btn-primary mx-1 sanksmall"
                  >
                    {t("Itrreports.buttons.print")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="firstrow2">
          <div className="table-containerbill">
            <div className="buttonsreportsank">
              {isSearchEnabled ? (
                <input
                  type="text"
                  className="form-control searchsank mx-3"
                  id="searchsank"
                  name="searchsank"
                  placeholder={t("Itrreports.filters.searchAccountNo")}
                  value={value}
                  onChange={filteData}
                  autoComplete="off"
                />
              ) : (
                <input
                  type="text"
                  disabled
                  className="form-control searchsank mx-3"
                  id="searchsank"
                  name="searchsank"
                  placeholder={dash}
                  value={value}
                  autoComplete="off"
                />
              )}

              <div className="radio">
                <div className="form-check">
                  <input
                    onClick={() => handlertype("retan")}
                    defaultChecked
                    className="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="radio1"
                    value="option1"
                  />
                  <label className="form-check-label" htmlFor="radio1">
                    {t("Itrreports.radios.retan")}
                  </label>
                </div>

                <div className="form-check">
                  <input
                    onClick={() => handlertype("karj")}
                    className="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="radio2"
                    value="option2"
                  />
                  <label className="form-check-label" htmlFor="radio2">
                    {t("Itrreports.radios.karj")}
                  </label>
                </div>
              </div>

              <div className="radio">
                <div className="form-check">
                  <input
                    onClick={() => handlertype("sanghpur")}
                    className="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="radio3"
                    value="option3"
                  />
                  <label className="form-check-label" htmlFor="radio3">
                    {t("Itrreports.radios.sanghpur")}
                  </label>
                </div>

                <div className="form-check">
                  <input
                    onClick={() => handlertype("shares")}
                    className="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="radio4"
                    value="option4"
                  />
                  <label className="form-check-label" htmlFor="radio4">
                    {t("Itrreports.radios.shares")}
                  </label>
                </div>
              </div>
            </div>

            {/* ---------------- tables ---------------- */}
            {khrtype === "retan" ? (
              <table id="myTablebill" className="table table-bordered">
                <thead>
                  <tr>
                    <th className="thsmallcustsmall2" scope="col">
                      {t("Itrreports.tables.retan.date")}
                    </th>
                    <th className="thsmallcustsmall" scope="col">
                      {t("Itrreports.tables.retan.account")}
                    </th>
                    <th className="thsmalllarge" scope="col">
                      {t("Itrreports.tables.retan.name")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.retan.type")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.retan.subType")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.retan.amount")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {rowsToShow &&
                    rowsToShow.map((user, index) => (
                      <tr key={index}>
                        <td className="thsmallcustsmall2">{formatDate(user.date)}</td>
                        <td className="thsmallcustsmall">{user.kno && user.kno !== "" ? user.kno : dash}</td>
                        <td className="thsmallcustlarge">{user.cname && user.cname !== "" ? user.cname : dash}</td>
                        <td className="thsmallcust">{user.type && user.type !== "" ? user.type : dash}</td>
                        <td className="thsmallcust">{user.etype && user.etype !== "" ? user.etype : 0}</td>
                        <td className="thsmallcust">{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                      </tr>
                    ))}
                </tbody>

                <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                  <td className="thsmallcustsmall2">{t("Itrreports.common.total")}</td>
                  <td className="thsmallcustsmall">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">
                    {(rowsToShow || []).reduce((total, user) => total + parseFloat(user.amt || 0), 0).toFixed(2)}
                  </td>
                </tr>
              </table>
            ) : khrtype === "karj" ? (
              <table id="myTablebill" className="table table-bordered">
                <thead>
                  <tr>
                    <th className="thsmallcustsmall2" scope="col">
                      {t("Itrreports.tables.karj.date")}
                    </th>
                    <th className="thsmallcustsmall" scope="col">
                      {t("Itrreports.tables.karj.account")}
                    </th>
                    <th className="thsmalllarge" scope="col">
                      {t("Itrreports.tables.karj.name")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.karj.type")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.karj.loanAmount")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {rowsToShow &&
                    rowsToShow.map((user, index) => (
                      <tr key={index}>
                        <td className="thsmallcustsmall2">{formatDate(user.date)}</td>
                        <td className="thsmallcustsmall">{user.kno && user.kno !== "" ? user.kno : dash}</td>
                        <td className="thsmallcustlarge">{user.cname && user.cname !== "" ? user.cname : dash}</td>
                        <td className="thsmallcust">{user.type && user.type !== "" ? user.type : dash}</td>
                        <td className="thsmallcust">{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                      </tr>
                    ))}
                </tbody>

                <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                  <td className="thsmallcustsmall2">{t("Itrreports.common.total")}</td>
                  <td className="thsmallcustsmall">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">
                    {(rowsToShow || []).reduce((total, user) => total + parseFloat(user.amt || 0), 0).toFixed(2)}
                  </td>
                </tr>
              </table>
            ) : khrtype === "shares" ? (
              <table id="myTablebill" className="table table-bordered">
                <thead>
                  <tr>
                    <th className="thsmallcustsmall2" scope="col">
                      {t("Itrreports.tables.shares.date")}
                    </th>
                    <th className="thsmallcustsmall" scope="col">
                      {t("Itrreports.tables.shares.account")}
                    </th>
                    <th className="thsmalllarge" scope="col">
                      {t("Itrreports.tables.shares.name")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.shares.type")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.shares.sharesAmount")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {rowsToShow &&
                    rowsToShow.map((user, index) => (
                      <tr key={index}>
                        <td className="thsmallcustsmall2">{formatDate(user.date)}</td>
                        <td className="thsmallcustsmall">{user.kno && user.kno !== "" ? user.kno : dash}</td>
                        <td className="thsmallcustlarge">{user.cname && user.cname !== "" ? user.cname : dash}</td>
                        <td className="thsmallcust">{user.type && user.type !== "" ? user.type : dash}</td>
                        <td className="thsmallcust">{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                      </tr>
                    ))}
                </tbody>

                <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                  <td className="thsmallcustsmall2">{t("Itrreports.common.total")}</td>
                  <td className="thsmallcustsmall">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">
                    {(rowsToShow || []).reduce((total, user) => total + parseFloat(user.amt || 0), 0).toFixed(2)}
                  </td>
                </tr>
              </table>
            ) : khrtype === "sanghpur" ? (
              <table id="myTablebill" className="table table-bordered">
                <thead>
                  <tr>
                    <th className="thsmallcustsmall2" scope="col">
                      {t("Itrreports.tables.sanghpur.date")}
                    </th>
                    <th className="thsmallcustsmall" scope="col">
                      {t("Itrreports.tables.sanghpur.account")}
                    </th>
                    <th className="thsmalllarge" scope="col">
                      {t("Itrreports.tables.sanghpur.name")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.sanghpur.type")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.sanghpur.subType")}
                    </th>
                    <th className="thsmall" scope="col">
                      {t("Itrreports.tables.sanghpur.amount")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {rowsToShow &&
                    rowsToShow.map((user, index) => (
                      <tr key={index}>
                        <td className="thsmallcustsmall2">{formatDate(user.date)}</td>
                        <td className="thsmallcustsmall">{user.kno && user.kno !== "" ? user.kno : dash}</td>
                        <td className="thsmallcustlarge">{user.cname && user.cname !== "" ? user.cname : dash}</td>
                        <td className="thsmallcust">{user.type && user.type !== "" ? user.type : dash}</td>
                        <td className="thsmallcust">{user.etype && user.etype !== "" ? user.etype : 0}</td>
                        <td className="thsmallcust">{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                      </tr>
                    ))}
                </tbody>

                <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                  <td className="thsmallcustsmall2">{t("Itrreports.common.total")}</td>
                  <td className="thsmallcustsmall">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">{dash}</td>
                  <td className="thsmallcust">
                    {(rowsToShow || []).reduce((total, user) => total + parseFloat(user.amt || 0), 0).toFixed(2)}
                  </td>
                </tr>
              </table>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Itrreports;
